import axios, { AxiosRequestConfig } from 'axios'
import TokenValidator from '@/services/token-validator'
import { User } from '@/types'
import { useAuthStore } from '@/store/modules/auth'

function getToken() {
  const userFromStorage: string | null = localStorage.getItem('user')
  if (userFromStorage !== null) {
    const user: User = JSON.parse(userFromStorage)
    if (user && user.accessToken) {
      try {
        TokenValidator.isTokenActive(user.accessToken)
        return user.accessToken
      } catch (error) {
        useAuthStore().logOutUser()
      }
    }
  }
  return null
}

const AXIOS = axios.create({
  baseURL: '/',
  headers: {
    'Content-type': 'application/json'
  }
})

AXIOS.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const newConfig: AxiosRequestConfig = config
    const token: string | null = getToken()
    if (token) {
      newConfig.headers!.Authorization = `Bearer ${token}`
    }
    return newConfig
  },
  error => {
    return Promise.reject(error)
  }
)

export default AXIOS
